import React from 'react';

function TotalCard({ label, value, bg }) {
    return (
        <div
        
            className={`p-10 sm:p-8 md:p-10 lg:p-12 xl:p-16 rounded-lg shadow-lg ${bg} flex flex-col justify-center items-center w-full`}
        >
            <p className="text-xs md:text-base text-center text-brand-text-light font-semibold">{label}</p>
            {/* Conditionally render additional content for "Total Sales" */}
            {label === "Total Sales" ? (
                <p className="text-xl font-bold mt-2">${value}</p>
            ) : (
                <p className="text-xl font-bold mt-2">{value}</p>
            )}
        </div>
    );
}

export default TotalCard;
